<template>
  <div class="exceed_container">
    <div
      class="exceed_box d-flex justify-center"
      :style="{ top: $vuetify.breakpoint.mdAndUp ? '25vh' : '10vh' }"
    >
      <div
        class="
          exceed_card
          mx-5 mx-md-none
          mb-3
          d-md-flex
          text-center
          flex-md-row-reverse
        "
      >
        <div class="card_image mt-8 mb-5 mt-md-n9 mb-lg-n6 ml-md-n5">
          <img
            :width="$vuetify.breakpoint.mdAndUp ? 'auto' : '224px'"
            src="../assets/exceed.svg"
            alt="image"
          />
        </div>
        <div class="card_info pt-md-9 pb-md-11 pl-md-10">
          <div
            class="card_title"
            :style="{ fontSize: $vuetify.breakpoint.mdAndUp ? '36px' : '26px' }"
          >
            You have exceeded<br />
            the limit
          </div>
          <div class="card_text mt-6 mb-4">Want to buy more {{ type }}?</div>
          <div class="card_buttons d-md-flex">
            <v-btn
              class="card_btn mt-3 mt-md-9"
              width="217px"
              height="60px"
              outlined
              rounded
              color="#2C4370"
            >
              Use {{ count + " " + type }}
            </v-btn>
            <v-btn
              class="card_btn mt-4 mt-md-9 mb-9 mb-lg-0 ml-md-9"
              :width="$vuetify.breakpoint.mdAndUp ? '156px' : '214px'"
              height="60px"
              rounded
              depressed
              dark
              color="#76CD68"
            >
              Yes, I want
            </v-btn>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AceedLimit",
  data() {
    return {
      count: "51615",
      type: "views",
    };
  },
};
</script>
<style scoped>
.exceed_container {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(44, 67, 112, 0.9);
  z-index: 9999;
  overflow-y: scroll !important;
}
.card_btn {
  font-weight: 500;
  font-size: 18px !important;
  text-transform: none;
}
.exceed_box {
  position: absolute;
  width: 100%;
  left: 0;
}
.exceed_card {
  background-color: #fff;
  border-radius: 20px;
}
.card_title {
  font-weight: bold;
  line-height: 1.15em;
  color: #172745;
}
.card_text {
  font-size: 18px;
  color: #172745;
}
</style>
